/** Impl dos use cases de DocumentoModelo. @since G.5.3 */
import type { DocumentoModelo, DocumentoModeloCommand } from '@/domain/model/DocumentoModelo';
import type { Page } from '@/domain/model/Page';
import type {
  DocumentoModeloGateway, ListDocumentoModelosParams,
} from '@/application/port/out/DocumentoModeloGateway';
import type {
  ListDocumentoModelosUseCase, GetDocumentoModeloUseCase,
  CreateDocumentoModeloUseCase, UpdateDocumentoModeloUseCase, DeactivateDocumentoModeloUseCase,
} from '@/application/port/in/DocumentoModeloUseCase';

export class ListDocumentoModelos implements ListDocumentoModelosUseCase {
  constructor(private readonly g: DocumentoModeloGateway) {}
  execute(params: ListDocumentoModelosParams): Promise<Page<DocumentoModelo>> { return this.g.list(params); }
}
export class GetDocumentoModelo implements GetDocumentoModeloUseCase {
  constructor(private readonly g: DocumentoModeloGateway) {}
  execute(id: string): Promise<DocumentoModelo> { return this.g.get(id); }
}
export class CreateDocumentoModelo implements CreateDocumentoModeloUseCase {
  constructor(private readonly g: DocumentoModeloGateway) {}
  execute(cmd: DocumentoModeloCommand): Promise<DocumentoModelo> { return this.g.create(cmd); }
}
export class UpdateDocumentoModelo implements UpdateDocumentoModeloUseCase {
  constructor(private readonly g: DocumentoModeloGateway) {}
  execute(id: string, cmd: DocumentoModeloCommand): Promise<DocumentoModelo> { return this.g.update(id, cmd); }
}
export class DeactivateDocumentoModelo implements DeactivateDocumentoModeloUseCase {
  constructor(private readonly g: DocumentoModeloGateway) {}
  execute(id: string): Promise<void> { return this.g.deactivate(id); }
}
